import { ToggleButton } from '@fountain/fountain-ui-components';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { messages } from '../messages';
import { ConversationDateFilter } from './ConversationDateFilter';
import {
  ConversationFilterMenu,
  FilterMenuItem,
} from './ConversationFilterMenu';
import { ConversationOpeningFilter } from './ConversationOpeningFilter';
import { ConversationFilters } from './conversationFilters';
import { useStyles } from './styles';

const channels = {
  widget: messages.channelWidget,
  sms: messages.channelSms,
  whatsapp: messages.channelWhatsapp,
  email: messages.channelEmail,
};

export const ConversationFilterBar = ({
  accountSlug,
  agentId,
  filters,
  onChange,
}: {
  accountSlug: string;
  agentId: string;
  filters: ConversationFilters;
  onChange: (filters: ConversationFilters) => void;
}) => {
  const intl = useIntl();
  const classes = useStyles();
  const [channelAnchor, setChannelAnchor] = useState<HTMLButtonElement | null>(
    null,
  );
  const selectChannel = (channel?: ConversationFilters['channel']) => {
    onChange({ ...filters, channel });
    setChannelAnchor(null);
  };
  return (
    <div data-testid="conversations-filter-bar" className={classes.filters}>
      <ConversationDateFilter filters={filters} onChange={onChange} />
      <ConversationOpeningFilter
        key={`${accountSlug}:${agentId}`}
        accountSlug={accountSlug}
        agentId={agentId}
        value={filters.opening}
        onChange={opening => onChange({ ...filters, opening })}
      />
      <ConversationFilterMenu
        name={intl.formatMessage(messages.filterChannel)}
        label={intl.formatMessage(
          filters.channel ? channels[filters.channel] : messages.channelAll,
        )}
        narrowed={!!filters.channel}
        anchor={channelAnchor}
        onOpen={setChannelAnchor}
        onClose={() => setChannelAnchor(null)}
      >
        <FilterMenuItem
          selected={!filters.channel}
          onClick={() => selectChannel()}
        >
          {intl.formatMessage(messages.channelAll)}
        </FilterMenuItem>
        {Object.entries(channels).map(([channel, message]) => (
          <FilterMenuItem
            key={channel}
            selected={filters.channel === channel}
            onClick={() =>
              selectChannel(channel as ConversationFilters['channel'])
            }
          >
            {intl.formatMessage(message)}
          </FilterMenuItem>
        ))}
      </ConversationFilterMenu>
      {(
        [
          ['thumbs_down', messages.filterThumbsDown],
          ['knowledge_gap', messages.filterKnowledgeGap],
        ] as const
      ).map(([key, message]) => (
        <ToggleButton
          key={`${key}:${filters[key] ?? ''}`}
          variant="default"
          defaultSelection=""
          selected={!!filters[key]}
          label={intl.formatMessage(message)}
          onToggleOn={() => onChange({ ...filters, [key]: 'true' })}
          onToggleOff={() => onChange({ ...filters, [key]: undefined })}
        />
      ))}
    </div>
  );
};
